import { useParams } from 'react-router-dom'
import { useDecision } from '@optimizely/react-sdk'
import { useOptimizely } from '../useOptimizely'
import { PathParams } from './useNewFeed.types'

const useNewFeed = () => {
  const { membership } = useParams<PathParams>()
  const [featureFlag] = useDecision('com_eng_web_enable_feed_v3')
  const { optimizely } = useOptimizely()

  const memberships = featureFlag?.variables?.memberships as { slugs: string[] }
  const isDisabledMembership = memberships && membership && memberships?.slugs?.includes(membership)
  const enabled = featureFlag.enabled && featureFlag.variationKey === 'on' && !isDisabledMembership

  return { enabled, optimizely }
}

export default useNewFeed
